export class ApiError extends Error {
    constructor(
        public message: string,
        public statusCode: number,
        public errors?: string[]
    ) {
        super(`API Error: ${message}`);
        this.name = 'ApiError';
        Object.setPrototypeOf(this, ApiError.prototype);
    }
}
